export const SERVICE_ROUTES = {
  // Main Services Index
  index: "/services",

  // Main Category Pages
  payrollIndex: "/services/payroll",
  hrIndex: "/services/hr-services",
  healthIndex: "/services/health-services",

  // AI & Technology Services
  dataScienceAi: "/services/data-science-ai",
  aiMlServices: "/services/ai-ml",
  dataScience: "/services/data-science",

  // Emerging Technology Services
  objectDetection: "/services/object-detection",
  edgeComputing: "/services/edge-computing",
  iotIntegration: "/services/iot-integration",

  // Security Services
  cyberSecurity: "/services/cyber-security",
  cloudSecurity: "/services/cloud-security",

  // Design & Development Services
  dataVisualization: "/services/data-visualization",
  uiUxDesign: "/services/ui-ux-design",
  mobileDevelopment: "/services/mobile-development",

  // Payroll Services
  payrollServices: "/services/payroll/services",
  payrollProcessing: "/services/payroll/processing",
  payrollSoftware: "/services/payroll/software",

  // HR Services
  hrInsights: "/services/hr-services/insights",
  partnerIntegration: "/services/hr-services/partner-integration",

  // BPO & Operations
  bpoServices: "/services/hr-services/bpo-services",
  contentModeration: "/services/hr-services/content-moderation",
  customerSupport: "/services/hr-services/customer-support",
  hrPayrollOperations: "/services/hr-services/hr-payroll-operations",
  recruitmentProcessOutsourcing:
    "/services/hr-services/recruitment-process-outsourcing",
  backOfficeOperations:
    "/services/hr-services/back-office-operations",
  dataEntryServices: "/services/hr-services/data-entry-services",
  technicalSupport: "/services/hr-services/technical-support",

  // Health Services
  medicalCoding: "/services/health-services/medical-coding",
  medicalBilling: "/services/health-services/medical-billing",
  revenueCycleManagement: "/services/health-services/revenue-cycle-management",
  claimsManagement: "/services/health-services/claims-management",
  insuranceEligibilityVerification:
    "/services/health-services/insurance-eligibility-verification",
};

export const SERVICE_VIEW_ROUTES = {
  services: SERVICE_ROUTES.index,
  payroll: SERVICE_ROUTES.payrollIndex,
  hr: SERVICE_ROUTES.hrIndex,
  health: SERVICE_ROUTES.healthIndex,
};
